import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgFire = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M15.398 4.802a21 21 0 0 0-1.916 2.104A27.4 27.4 0 0 0 10.088 3C6.732 6.203 4.35 10.383 4.35 12.9c0 4.475 3.422 8.1 7.65 8.1s7.65-3.625 7.65-8.1c0-1.87-1.776-5.734-4.252-8.098M12 19.312c-3.313 0-6.01-2.878-6.01-6.412 0-1.595 1.51-4.683 4.1-7.527a24 24 0 0 1 2.064 2.528l1.25 1.771 1.345-1.696q.302-.376.615-.739c1.585 2.02 2.647 4.566 2.647 5.663 0 3.533-2.698 6.413-6.011 6.413m3.057-7.766-1.755 2.057s-2.745-3.607-2.95-3.853c-1.453 1.79-2.177 2.834-2.177 4.022 0 2.387 1.755 3.853 3.91 3.853.863 0 1.661-.277 2.31-.742 1.469-1.06 1.814-3.116.999-4.722a14 14 0 0 0-.337-.614"
    }));
export default SvgFire;
